import apiAthlete from '@/api/athlete'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createAthleteStart: '[create athlete] Create athlete start',
  createAthleteSuccess: '[create athlete] Create athlete success',
  createAthleteFailure: '[create athlete] Create athlete failure'
}

export const actionTypes = {
  createAthlete: '[create athlete] Create athlete'
}

const mutations = {
  [mutationTypes.createAthleteStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createAthleteSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createAthleteFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createAthlete](context, {athlete}) {
    context.commit(mutationTypes.createAthleteStart)
    return new Promise(resolve => {
      apiAthlete
        .createArticle(athlete)
        .then(res => {
          context.commit(mutationTypes.createAthleteSuccess)
          resolve(res.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createAthleteFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
